var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGoogleMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4926_10446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 7.9881L13.2615 10.0161L15.8825 11.5406L16.3384 8.0009L15.8825 4.54102L13.2113 5.88028L11.3125 7.9881Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 11.2105V14.2269C0.00390625 14.9156 0.618038 15.4748 1.37477 15.4748H4.6883L5.37444 13.1957L4.6883 11.2105L2.41498 10.5859L0.00398434 11.2105H0.00390625Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6883 0.5L0.00390625 4.76427L2.41514 5.38737L4.6883 4.76427L5.36194 2.80609L4.6883 0.5Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 11.2113H4.68823V4.76367H0.00390625V11.2113Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8753 2.30521L15.8828 4.54V11.5395L18.8876 13.783C19.3375 14.1037 19.9955 13.8114 19.9955 13.2909V2.78734C19.9955 2.26106 19.3218 1.97016 18.8752 2.30528",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3128 7.98828V11.2114H4.6875V15.4756H14.5121C15.2688 15.4756 15.8828 14.9164 15.8828 14.2277V11.5408L11.3128 7.98828Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5121 0.5H4.6875V4.76427H11.3128V7.98735L15.8829 4.54019V1.74799C15.8829 1.05912 15.2688 0.500071 14.5121 0.500071",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4926_10446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogleMeet);
export default __webpack_public_path__ + "static/media/ic_google-meet.2ad4e14d53c0aec65528498c24b4497f.svg";
export { ForwardRef as ReactComponent };